import React from 'react'
import { useImageLoaded } from '~/hooks/useImage'

const BunnyImage = (props: React.HTMLProps<HTMLImageElement>) => {
  const [imageRef, loaded, onLoad] = useImageLoaded();

  return (
    <img
      className={`image--${loaded ? 'loaded' : 'loading'}`}
      ref={imageRef}
      onLoad={onLoad}
      {...props}
    />
  )
}

export default BunnyImage
